import React from 'react'
import { Row, Typography } from 'antd'

const { Text } = Typography

export interface InfoItemProps {
  label: string
  value: string | number | undefined | null
}

export const InfoItem: React.FC<InfoItemProps> = ({ label, value }) => (
  <Row justify="space-between" style={{ marginBottom: 4 }}>
    <Text type="secondary">{label}:</Text>
    <Text>{value ?? '-'}</Text>
  </Row>
)
